import { useCallback, useMemo, useState } from 'react';
import { SelectChangeEvent } from '@mui/material';

import { sortStrategies } from '../helpers';
import { IDirectionToSort, IKeyToSort, ITagsSelectProps, ITypeSort } from '../types';

export const useSortEntityWithCount = ({ entityWithCount }: { entityWithCount: ITagsSelectProps['tag'] }) => {
  const [typeSort, setTypeSort] = useState<ITypeSort>({
    keyToSort: IKeyToSort.NUMBER,
    direction: IDirectionToSort.DESC,
  });

  const sortedValues = useMemo(() => {
    const strategies = sortStrategies(typeSort.direction);
    const sortStrategy = strategies[typeSort.keyToSort];

    const validKeys = Object.keys(strategies) as IKeyToSort[];
    if (!validKeys.includes(typeSort.keyToSort)) {
      throw new Error(`Invalid sort key: ${typeSort.keyToSort}`);
    }

    return [...entityWithCount.values].sort(sortStrategy);
  }, [entityWithCount, typeSort]);

  const handleChange = useCallback((event: SelectChangeEvent) => {
    const { value } = event.target;

    setTypeSort((prevState) => ({
      ...prevState,
      keyToSort: value as IKeyToSort,
    }));
  }, []);

  const changeDirectionSort = useCallback(() => {
    return setTypeSort((prevState) => ({
      ...prevState,
      direction: prevState.direction === IDirectionToSort.ASC ? IDirectionToSort.DESC : IDirectionToSort.ASC,
    }));
  }, []);

  const searchOptions = sortedValues.map((e) => ({
    label: e.value ?? 'Unknown Label',
    value: e.value ?? undefined,
  }));
  return {
    searchOptions,
    hasValues: sortedValues.length > 0,
    typeSort,
    handleChange,
    changeDirectionSort,
  };
};
